module.exports = __webpack_public_path__ + "static/img/envelope.45b307a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/envelope.png
// module id = 6ss9
// module chunks = 1 3